export enum ReportType {
	SuccessfulLoginAttempts = 'SUCCESSFUL_LOGIN_ATTEMPTS',
	Users = 'USERS'
}
